import layout from '@/layout'

export default {
  path: '/info',
  component: layout,
  redirect: '/info/user',
  name: 'info_user',
  meta: {
    title: 'info',
    icon: 'info'
  },
  children: [
    {
      path: '/info/user',
      name: 'info_user',
      component: () => import('@/views/info/user/index'),
      meta: {
        title: 'info_user',
        icon: 'info'
      }
    }
  ]
}
